import { ErrorHandler, Injectable, inject } from '@angular/core';
import { StructuredLoggerService } from './structured-logger.service';
import { TelemetryService } from './telemetry.service';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  private readonly logger = inject(StructuredLoggerService);
  private readonly telemetry = inject(TelemetryService);

  handleError(error: unknown): void {
    this.logger.logException(error, 'global-error-handler');
    void this.telemetry.recordException(error, 'global-error-handler');
    console.error(error);
  }
}

